// NEW badge on menus: the API sends newUntil (last day to show NEW) per menu at login.

const pad = (n) => String(n).padStart(2, "0");

/** Today as YYYY-MM-DD in the browser's own time zone. */
export const localToday = (d = new Date()) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

/** True while the menu is still new (newUntil is today or later). */
export const isMenuNew = (newUntil, today = localToday()) =>
  !!newUntil && String(newUntil).slice(0, 10) >= today;

/** True when the menu, or any of its children, is new. */
export const hasNewChild = (children, today = localToday()) =>
  (children || []).some((c) => isMenuNew(c.newUntil, today));
